import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { getAllPagesByBoardId, getPagesByUserId } from '../../services/pages'
import { getAuth } from '../../modules/auth/core/AuthHelpers'

const initialState: any = {
    pagesByBoardId: [],
    pagesByLoggedInUser: [],
    myPages: [],
    sharedPages: [],
    selectedPage: null,
    loading: false,
}

export const fetchAllPagesByBoardId: any = createAsyncThunk(
    'pageSlice/fetchAllPagesByBoardId',
    async ({ boardId }: { boardId: string }) => {
        try {
            const response = await getAllPagesByBoardId(boardId)
            return response.data.data.pages
        } catch (error) {
            return error
        }
    }
)
export const fetchAllPagesByLoggedInUser: any = createAsyncThunk(
    'pageSlice/fetchAllPagesByLoggedInUser',
    async ({ id }: { id: string }) => {
        try {
            const response = await getPagesByUserId(id)
            return response.data.data.pages.map((item: any) => item.page);
        } catch (error) {
            return error
        }
    }
)
export const pageSlice = createSlice({
    name: 'pageSlice',
    initialState,
    reducers: {
        setSelectedPage: (state, action) => {
            state.selectedPage = action.payload;
        },
        addPageInLoggedInUser: (state, action) => {
            state.pagesByLoggedInUser.push(action.payload);
        },
        addPageInHome: (state, action) => {
            if (action.payload.id === 'My pages') {
                state.myPages.unshift(action.payload.page);
            } else {
                state.sharedPages.unshift(action.payload.page);
            }
        },
        updateHomePages: (state, action) => {
            if (action.payload.id === 'My pages') {
                const index = state.myPages.findIndex((page: any) => page.id === action.payload.updatedPage.id);
                if (index !== -1) {
                    state.myPages.splice(index, 1); // Remove the old one
                }
                state.myPages.unshift(action.payload.updatedPage); // Add to index 0
            } else {
                const index = state.sharedPages.findIndex((page: any) => page.id === action.payload.updatedPage.id);
                if (index !== -1) {
                    state.sharedPages.splice(index, 1); // Remove the old one
                }
                state.sharedPages.unshift(action.payload.updatedPage); // Add to index 0
            }

        },
        editPageInLoggedInUser: (state, action) => {
            const existingPageInBoard = state.pagesByBoardId.find((page: any) => page.id === action.payload.id);
            const existingPageInLoggedInuser = state.pagesByLoggedInUser.find((page: any) => page.id === action.payload.id);
            if (existingPageInBoard) {
                Object.assign(existingPageInBoard, action.payload);
            }
            if (existingPageInLoggedInuser) {
                Object.assign(existingPageInLoggedInuser, action.payload);
            }
        },
        removePageById: (state, action) => {
            // Filter pagesByBoardId and pagesByLoggedInUser independently
            state.pagesByBoardId = state.pagesByBoardId.filter((page: any) => page.id !== action.payload);
            state.pagesByLoggedInUser = state.pagesByLoggedInUser.filter((page: any) => page.id !== action.payload);
            // Also ensure myPages/sharedPages reflect the deletion
            state.myPages = state.myPages.filter((page: any) => page.id !== action.payload);
            state.sharedPages = state.sharedPages.filter((page: any) => page.id !== action.payload);
            // If the selected page was deleted, clear it
            if (state.selectedPage && state.selectedPage.id === action.payload) {
                state.selectedPage = null;
            }
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchAllPagesByBoardId.pending, (state) => {
            state.loading = true
        })
        builder.addCase(fetchAllPagesByBoardId.fulfilled, (state: any, action) => {
            state.pagesByBoardId = action.payload
            state.loading = false
        })
        builder.addCase(fetchAllPagesByBoardId.rejected, (state) => {
            state.loading = false
            // state.errors = action.payload
        })
        builder.addCase(fetchAllPagesByLoggedInUser.pending, (state) => {
            state.loading = true
        })
        builder.addCase(fetchAllPagesByLoggedInUser.fulfilled, (state: any, action) => {
            const authData:any = getAuth();
            const userId = authData?.data?.user?.id;
            state.pagesByLoggedInUser = action.payload;
            state.myPages = [];
            state.sharedPages = [];

            (action.payload || []).forEach((item: any) => {
                if (item.createdByUserId === userId) {
                    state.myPages.push(item);
                } else {
                    state.sharedPages.push(item);
                }
            });
            state.loading = false
        })
        builder.addCase(fetchAllPagesByLoggedInUser.rejected, (state) => {
            state.loading = false
            // state.errors = action.payload
        })
    }
})
export const { addPageInLoggedInUser, editPageInLoggedInUser, updateHomePages, setSelectedPage, addPageInHome,removePageById } = pageSlice.actions
export default pageSlice.reducer
